// extracted by mini-css-extract-plugin
export default {"menuSectionLink":"iaffPC2agmavD482alEn","icon":"qVDgB6Nkv7FDbtOSIJqa","active":"r1JHEVibvWn0bLpGICT4"};